module.exports = __webpack_public_path__ + "static/RightCloudBlue-69870f6c493eff049f5d006df220ca2f.svg";